import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import { MeetingService } from 'src/app/service/meeting.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { DeleteMeetingPopupComponent } from '../delete-meeting-popup/delete-meeting-popup.component';

@Component({
  selector: 'app-cancel-meeting-popup',
  templateUrl: './cancel-meeting-popup.component.html',
  styleUrls: ['./cancel-meeting-popup.component.css']
})
export class CancelMeetingPopupComponent implements OnInit {

  meetingId: any;
  reason:any
  private readonly notifier!: NotifierService;

  constructor(notifierService: NotifierService,private sideNav : SideNavServiceService,private meetingService: MeetingService,private _mdr: MatDialogRef<DeleteMeetingPopupComponent>,@Inject(MAT_DIALOG_DATA) data: any) { 
    this.notifier = notifierService;
   // this.meetingId = data.meetingId.meetingId;
   this.meetingId = data['meetingId'];
    
  }

  ngOnInit(): void {
  }
  
  cancelMeeting(){
    var deleteMeetingJson = {
      "meetingId":this.meetingId,
      "cancelledReason":this.reason
    };

    if(this.reason != null && this.reason != undefined && this.reason!="null" && this.reason != ""){

      this.meetingService.cancelMeeting(deleteMeetingJson).subscribe((resp:any)=>{
        this.notifier.show({
          type: 'success',
          message: 'Meeting Cancelled Successfully'
        });
        this._mdr.close(true)
      });
    }else{
      this.sideNav.alertMeetingReason('Enter reason for the cancellation','error');
    }
  }
  closeDialog() {
    this._mdr.close(false)
  }

}
